import { mapGetters } from 'vuex'
import CHECKOUT_STEP from '@/constants/checkout-step'

const CHECKOUT_USER_FEEDBACK_PAGE = {
  landing_page: 'landing_page',
  id_verification: 'id_verification',
  payment_plan: 'payment_plan',
  unknown: 'unknown',
}

export default {
  computed: {
    ...mapGetters('checkout', ['currentStep', 'userHasTriedToPay']),
    ...mapGetters('session', [
      'paymentType',
      'singleCheckoutRevampEnabled',
      'countryCode',
    ]),
    ...mapGetters('configuration', ['userCheckoutFeedbackEnable']),
    uqudoVerificationStep() {
      return this.$route.path === '/uqudo-verification'
    },
    isIdVerificationStep() {
      if (this.uqudoVerificationStep) return true

      return [
        CHECKOUT_STEP.id_verification_sau,
        CHECKOUT_STEP.id_verification_sau_confirm,
        CHECKOUT_STEP.id_verification_are,
        CHECKOUT_STEP.id_verification_routing,
        CHECKOUT_STEP.id_verification_nafath_waiting,
        CHECKOUT_STEP.ID_VERIFICATION_UQUDO_INSTANT_APP_LINK,
      ].includes(this.currentStep)
    },
    isPaymentPlanStep() {
      return [
        CHECKOUT_STEP.pay_by_later_confirmation,
        CHECKOUT_STEP.pay_by_later_require_payment_method,
        CHECKOUT_STEP.pay_by_instalment_confirmation,
        CHECKOUT_STEP.pay_by_instalment_charge_down_payment,
        CHECKOUT_STEP.pay_now_confirmation,
        CHECKOUT_STEP.pay_now_charge_payment,
        CHECKOUT_STEP.risk_consult_response_handling,
        CHECKOUT_STEP.risk_consult_response_handling_3rd_fraud_check,
      ].includes(this.currentStep)
    },
    userCheckoutFeedbackConfig() {
      if (!TypeChecker.isArray(this.userCheckoutFeedbackEnable)) {
        return {}
      }

      return this.userCheckoutFeedbackEnable.find(
        ({ paymentType }) => paymentType === this.paymentType
      )
    },
    isRequiredAnswer() {
      return !!this.userCheckoutFeedbackConfig?.required
    },
    userFeedbackStep() {
      if (this.$route.name === 'login') {
        return CHECKOUT_USER_FEEDBACK_PAGE.landing_page
      }

      if (this.isIdVerificationStep) {
        return CHECKOUT_USER_FEEDBACK_PAGE.id_verification
      }

      if (this.isPaymentPlanStep) {
        return CHECKOUT_USER_FEEDBACK_PAGE.payment_plan
      }

      return CHECKOUT_USER_FEEDBACK_PAGE.unknown
    },
    isEnabledConfigByCurrentStep() {
      const feedbackConfig = this.userCheckoutFeedbackConfig

      return (
        {
          [CHECKOUT_USER_FEEDBACK_PAGE.landing_page]:
            !!feedbackConfig?.landingPage,
          [CHECKOUT_USER_FEEDBACK_PAGE.id_verification]:
            !!feedbackConfig?.idVerification,
          [CHECKOUT_USER_FEEDBACK_PAGE.payment_plan]:
            !!feedbackConfig?.paymentPlan,
        }[this.userFeedbackStep] || false
      )
    },
    isEnabledUserCheckoutFeedback() {
      return false // this.isEnabledConfigByCurrentStep
    },
    feedbackQuestionCode() {
      if ((window?.location?.pathname ?? '') === '/login') {
        return 'checkout.user_feedback.login'
      }

      if (this.isIdVerificationStep) {
        return (
          {
            AE: 'checkout.user_feedback.idv_uae',
            SA: 'checkout.user_feedback.idv_ksa',
          }[this.countryCode] || 'checkout.user_feedback.question3'
        )
      }

      if (this.userHasTriedToPay) {
        return 'checkout.user_feedback.payment_confirmation'
      }

      if (this.isPaymentPlanStep) {
        return 'checkout.user_feedback.payment_plan'
      }

      if (this.singleCheckoutRevampEnabled) {
        return 'checkout.user_feedback.question2'
      }

      return 'checkout.user_feedback.question1'
    },
  },
}
